import { render, staticRenderFns } from "./ProjectAdmin.vue?vue&type=template&id=3494c896&scoped=true"
import script from "./ProjectAdmin.vue?vue&type=script&lang=js"
export * from "./ProjectAdmin.vue?vue&type=script&lang=js"
import style0 from "./ProjectAdmin.vue?vue&type=style&index=0&id=3494c896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3494c896",
  null
  
)

export default component.exports